<div class="body-container">
  <div class="body-content">
    @if (loading) {
      <div class="loading-container">
        <div class="loading-div">
          <mat-spinner diameter="20" value="80"></mat-spinner>
          <span>{{'common.loading' | translate}}</span>
        </div>
      </div>
    }
    <mat-sidenav-container autosize>
      <mat-sidenav
        #drawer
        mode="over"
        [opened]="openSideMenu"
        position="start"
        disableClose="false"
        >
        <div class="side-nav-body left-menu">
          <div class="align-right">
            <div class="sidebar-icon-container">
              <button
                [attr.aria-label]="'aria.side-nav-toggle' | translate"
                mat-icon-button
                class=""
                (click)="drawer.toggle()"
                >
                <i class="fas fa-bars"></i>
              </button>
            </div>
            <app-sidebar></app-sidebar>
          </div>
        </div>
      </mat-sidenav>
      <mat-sidenav
        #drawermenu
        mode="over"
        [opened]="openSidebar"
        (closed)="onSidebarClose()"
        position="end"
        >
        <div class="side-nav-body">
          <div class="align-right">
            <button style="font-size:18px;" class="mt-3 mr-2 float-right"
              [attr.aria-label]="'aria.close_side_menu' | translate"
              mat-icon-button
              (click)="drawermenu.toggle()"
              >
              <i class="fas fa-times"></i>
            </button>
            <router-outlet
              name="sidebar"
              (activate)="openSidebar = true"
              (deactivate)="openSidebar = false"
              >
            </router-outlet>
          </div>
        </div>
      </mat-sidenav>
      <div class="webcontainer">
        <nav id="sidebar">
          <div class="bar-icon-container flex-center">
            <button
              [attr.aria-label]="'aria.side-nav-toggle' | translate"
              mat-icon-button
              (click)="drawer.toggle()"
              >
              <i class="fas fa-bars"></i>
            </button>
          </div>
        </nav>
        <header id="header">
          <div class="logo"></div>
          <div class="flex-row align-items-center">

            @if (siteType !== 'production') {
              <div class="small-div site-type-indicator mr-1">
                @if (siteType=='demo') {
                  <span>Demo Site</span>
                }
                @if (siteType=='uat') {
                  <span>UAT Site</span>
                }
                @if (siteType=='dev') {
                  <span>Local Dev Site</span>
                }
              </div>
            }

            <button  [uw-permission]="[permissionEnum.uwUserLoginMoniotor]"
              [attr.aria-label]="'aria.view_user_access_logs' | translate"
              mat-icon-button
              [routerLink]="['/', 'private', 'uwsetup', 'monitor-user-access']"
              >
              <i class="far fa-eye header-option"></i>
            </button>
            @if (this.isSuperAdmin$ | async) {
              <div>
                @if (selectedUnitedWayName) {
                  <button
                    [attr.aria-label]="'aria.select_united_way' | translate"
                    mat-button
                    [matMenuTriggerFor]="menu"
                    >
                    <i class="fas fa-random"></i>
                    <span class="header-btn-label">{{
                      selectedUnitedWayName
                    }}</span>
                  </button>
                }
              </div>
              <mat-menu #menu="matMenu" xPosition="before">
                <div>
                  @for (uw of unitedWayList$ | async; track uw) {
                    <div
                      tabindex="0"
                      role="button"
                      class="uw-menu-item"
                      [ngClass]="{ selected: selectedUnitedWayName === uw.name }"
                      (keydown)="onKeydown($event, uw.unitedWayId)"
                      (click)="switchContent(uw.unitedWayId)"
                      >
                      <span>{{ uw.name }}</span>
                    </div>
                  }
                </div>
              </mat-menu>
            }

            @if (authService.hasDonorRole()) {
              <button
                mat-button
                class="text-btn header-option"
                (click)="switchToDonationSite()"
                >
                {{ "header.switch_to_donation_site" | translate }}
              </button>
            }

            <button
              [attr.aria-label]="'aria.lang' | translate"
              mat-button
              class="text-btn header-option"
              (click)="changeLang($event)"
              >
              {{ "header.lang" | translate }}
            </button>

            <button
              [attr.aria-label]="'aria.view_helpdesk' | translate"
              mat-icon-button
              [routerLink]="['/', 'private', 'help-desk']"
              >
              <!-- <i class="fa-solid fa-headset header-option"></i> -->
              <mat-icon class="header-option">headset_mic</mat-icon>
            </button>

            <button
              [attr.aria-label]="'aria.view_faq' | translate"
              mat-icon-button
              [routerLink]="['/', 'private', 'faqs']"
              >
              <i class="far fa-question-circle header-option"></i>
            </button>

            <button
              [attr.aria-label]="'aria.view_profile' | translate"
              (click)="onSideMenuClick()"
              mat-icon-button
              >
              <i class="far fa-user-circle btn-header-icon header-option"></i>
            </button>
          </div>
        </header>
        @if (alerts && alerts.length) {
          <div class="p-4">
            @for (alert of alerts; track alert; let i = $index) {
              <uw-alert [type]="alert.type" (close)="onAlertClose(i)">
                <span>{{alert.message}}</span>
              </uw-alert>
            }
          </div>
        }
        <main>
          <div class="sub-header">
            <uw-subheader></uw-subheader>
          </div>
          <div class="content">
            <router-outlet></router-outlet>
          </div>
        </main>
        <footer>
          <!-- <div>FAQs | {{ "common.privacy_policy" | translate }} | {{ "common.help" | translate }}</div> -->
          <div>
            {{ "common.copyright" | translate }} © 2026 United Way Greater
            Toronto. {{ "common.all_right_reserved" | translate }}. <small>v{{version}}</small>
          </div>
          <div class="text-center">
            <a target="_blank" [href]="informationSecurityFrameworkPolicyFileUrl"> {{"footer.information_security_framework_policy_file_label" | translate}} </a>
          </div>
        </footer>
      </div>
    </mat-sidenav-container>
  </div>
</div>
